module.exports = __webpack_public_path__ + "static/media/DarwinWhite.1ef84fdb.svg";